import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatUpdatedAgo, getCookie } from '../../home/app_util';

export class EventDetail extends Component {
  render() {
    let token = getCookie('token');
    if (!token) {
      token = '';
    }
    const { redirectUrl, event, projectId, version } = this.props;
    const { eventTitle, uuid, updatedAt } = event;
    const updatedAgo = formatUpdatedAgo(updatedAt);
    return (
      <Fragment>
        <a
          className={`list-group-item list-group-item-action align-items-center`}
          style={{ cursor: 'pointer', float: 'left' }}
          href={`${redirectUrl}events/${version}/v/${projectId}/event/${uuid}?token=${token}`}
        >
          <i className="gjs-caret-icon wb webconnect-diagram-2-fill"></i>&nbsp;{eventTitle}
          <br />
          <small className="text-muted ml-3">{`Updated ${updatedAgo}`}</small>
        </a>
      </Fragment>
    );
  }
}

EventDetail.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventDetail;
